import { RadioGroup } from '@mui/material'
import { RadioGroupOption } from '@obeta/models/lib/models/UI'
import { FC } from 'react'
import { RadioItem } from '../radio-item/RadioItem'

type CarouselMobileFiltersProps = {
  options: RadioGroupOption[]
  value: string | number
  onChange: (value: string | number) => void
}

export const CarouselMobileFilters: FC<CarouselMobileFiltersProps> = (props) => {
  const { options, value, onChange } = props

  return (
    <RadioGroup>
      {options.map((option) => (
        <RadioItem
          id={option.value as string}
          checked={value === option.value}
          label={option.label}
          value={option.value}
          onChange={(event) => onChange(option.value ?? '')}
        />
      ))}
    </RadioGroup>
  )
}
